import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { getCasualOverviewInfo } from '@home/services/studio';

const CasualOverviewWrap: React.FC<any> = (props) => {
  const { tabFilter, config, children, data: propsData,...restProps } = props;

  const [casualInfo, setCasualInfo] = useState<any>(null);

  useEffect(() => {
    getCasualOverviewInfo({ studio_code: propsData?.frameCode }).then((res) => {
      setCasualInfo(res);
    }).catch((err) => {
      console.error('getCasualOverviewInfo error:', err);
    });
  }, []);

  const startDate = tabFilter?.startDate;
  const endDate = tabFilter?.endDate;
  const dateType = tabFilter?.dateType || 'monthly';
  const isDaily = dateType === 'daily';

  const filter = useMemo(() => {
    if (!startDate || !endDate) {
      return { start_time: startDate, end_time: endDate, date_type: dateType, is_confirm: false };
    }

    const isSingle = isDaily
      ? startDate === endDate
      : moment(startDate).year() === moment(endDate).year() &&
        moment(startDate).month() === moment(endDate).month();

    return {
      start_time: startDate,
      end_time: endDate,
      date_type: dateType,
      is_confirm: !isSingle,
    };
  }, [startDate, endDate, dateType, isDaily]);

  const data = useMemo(() => {
    return{
      ...propsData,
      filter,
      casualInfo,
    };
  }, [propsData, filter, casualInfo]);

  if (!startDate || !endDate) {
    return null;
  }

  return (
    React.Children.map(children, (child: any) =>
      React.cloneElement(child, {
        ...(restProps || {}),
        filter,
        data,
      }),
    )
  );
};

export default CasualOverviewWrap;
